// extracted by mini-css-extract-plugin
module.exports = {"landing_page_C":"C_landing_page_C__gvRDe"};